module.exports = __webpack_public_path__ + "images/89036fd1b4ccf107b96b39016ff98ac3.svg";